module.exports = __webpack_public_path__ + "static/hero-01-08671f52921189d2a31d401fcd2b8a9e.jpg";